import { DosageReminderPatientItemSearch, DosageRemindersSearch } from "../types";

export const urls = {
  dosageReminders: () => "/api/client/v1/medication-adherence/medication-dosage-reminders/",
  dosageReminder: (id: number) =>
    `/api/client/v1/medication-adherence/medication-dosage-reminders/${id}/`,
  dosageReminderRecentItems: () =>
    "/api/client/v1/medication-adherence/medication-dosage-reminders/recent-items/",
  dosageReminderPatientItem: () =>
    "/api/client/v1/medication-adherence/medication-dosage-reminders/patient-item/",
};

export const keys = {
  all: () => ["dosage-reminders-all"],
  dosageReminder: () => [...keys.all(), "dosage-reminders"],
  dosageReminderLists: () => [...keys.dosageReminder(), "list"],
  dosageReminderList: (search: DosageRemindersSearch = {}) => [
    ...keys.dosageReminderLists(),
    search,
  ],
  dosageReminderDetails: () => [...keys.dosageReminder(), "detail"],
  dosageReminderDetail: (id: number) => [...keys.dosageReminderDetails(), id],
  dosageReminderRecentItems: () => [...keys.dosageReminder(), "recent-items"],
  dosageReminderPatientItem: (search: DosageReminderPatientItemSearch) => [
    ...keys.dosageReminder(),
    "patient-item",
    search,
  ],
};
